
export default (uuid) => {
  return uuid.toString().split('-')[0]
}
